import { z } from 'zod'
import { PermissionType } from '@library/enums'
import { getPermissionDataSchema } from '@library/utils/zod'

/** 權限型別 */
export const permissionDataSchema = getPermissionDataSchema(
  z.enum(PermissionType)
)

export interface PermissionData extends z.infer<typeof permissionDataSchema> {}
